import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export default makeStyles<{}>(
  {
    root: {
      width: '100%',
      [theme.breakpoints.down('md')]: {
        paddingLeft: 50
      },
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 'unset',
        alignItems: 'center',
        flexDirection: 'column'
      }
    },
    content: {
      transform: 'translateY(-19px)'
    },
    title: {
      color: 'rgba(255, 255, 255)',
      fontSize: 15,
      fontWeight: 300,
      lineHeight: 1.2
    },
    answer: {
      color: '#FFF',
      fontSize: 16,
      lineHeight: 1,
      background: 'transparent',
      paddingLeft: 0,
      paddingTop: 7,
      maxHeight: 120,
      height: '100%',
      wordBreak: 'break-word',
      overflowY: 'auto',
      '&::-webkit-scrollbar': {
        width: 5
      },
      '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 5px #e1dddd',
        borderRadius: 10
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#FFF',
        borderRadius: 10
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(255, 255, 255, 0.6)'
      }
    }
  },
  { index: 1 }
)
